import { AdvancedTourStep } from '../shared-types';
import { TaskTourProps } from './task-tour-props';

export function getParallelJoinTourSteps({
	defaultStyles,
}: Readonly<TaskTourProps>): AdvancedTourStep[] {
	return [
		{
			id: 'wait-time',
			selector: '[data-tour="wait-time"]',
			content:
				'Required: This is the amount of time in seconds that the task will wait since receiving the first payload until it fails the execution.',
		},
		{
			id: 'continue-partial',
			selector: '[data-tour="continue-partial"]',
			content:
				'When checked, the task will continue to the next task, even if not all input tasks has succeeded.',
		},
		{
			id: 'flat-join',
			selector: '[data-tour="flat-join"]',
			content:
				'When checked, the different payloads from the input tasks are not joined into a single record, but remain separate records.',
		},
	].map(tourItem => ({ ...tourItem, styles: defaultStyles }));
}
